import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ReactiveFormsModule, FormControl, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { NgToastService } from 'ng-angular-popup';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RfqSectionDialogsComponent } from '@/app/components/projects/project-requests/requested-tendering/requested-rfq/rfq-section-dialogs/rfq-section-dialogs.component';
import { Router } from '@angular/router';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { RequestForQuotationService } from '@/app/services/tendering-services/rfq/rfq.service';
@Component({
  standalone: true,
  providers: [provideNativeDateAdapter()],
  imports: [
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDatepickerModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-rfq-conclusion',
  templateUrl: './rfq-conclusion.component.html',
  styleUrls: ['./rfq-conclusion.component.css'],
})
export class RfqConclusionComponent implements OnInit {
  @Output() closeModalEvent = new EventEmitter<boolean>();
  @Input() rfpResponseData: any;
  @Input() tendererResponseData: any;

  isEdit = false;
  projectId: number;
  closeModal = true;
  ittId: number;

  form: FormGroup = new FormGroup({
    your_name_control: new FormControl('', Validators.required),
    your_position_control: new FormControl('', Validators.required),
    company_name_control: new FormControl(''),
    contact_information_control: new FormControl(''),
  });

  constructor(
    private RfqSectionDialogsComponent: RfqSectionDialogsComponent,
    private toast: NgToastService,
    private router: Router,
    private requestForQuotationService: RequestForQuotationService,
    private GetProjectIdService: GetProjectIdService
  ) {}

  ngOnInit(): void {
    this.projectId = +this.GetProjectIdService.getProjectId();
    this.ittId = this.requestForQuotationService.getRFQId();
    this.requestForQuotationService.isEdit$.subscribe((state) => {
      this.isEdit = state;
    });

    if (this.tendererResponseData) {
      this.mapRFPExistingData();
    }
  }

  moveToPreviousStep() {
    this.RfqSectionDialogsComponent.previousStep();
  }

  prepareDataToSubmit() {
    if (this.form.valid) {
      const data = {
        tenderer_name: this.form.value.your_name_control,
        tenderer_position: this.form.value.your_position_control,
        tenderer_company_name: this.form.value.company_name_control,
        tenderer_contact_information:
          this.form.value.contact_information_control,
      };
      return data;
    }
  }

  moveToNextStep() {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      this.toast.warning(
        'Please fill in all required fields.',
        'WARNING',
        4000
      );
      return;
    }
    const dataToSubmit = this.prepareDataToSubmit();
    this.requestForQuotationService
      .addRfqConclusion(dataToSubmit, this.ittId)
      .subscribe({
        next: (response: any) => {
          if (!response?.meta?.success) {
            return;
          }
          this.toast.success('Conclusion submitted ', 'SUCCESS');
          this.closeModalEvent.emit(this.closeModal); // Emit closeModal value to the parent
        },
        error: (error: any) => {
          console.error('Failed to submit:', error);
          this.toast.danger(error.error.message, 'DANGER', 4000);
        },
      });
  }
  mapRFPExistingData() {
    if (!this.tendererResponseData) {
      console.warn('Tenderer Response Data is undefined');
      return;
    }

    this.form.setValue({
      your_name_control: this.tendererResponseData.tendererName ?? '',
      your_position_control: this.tendererResponseData.tendererPosition ?? '',
      company_name_control: this.tendererResponseData.tendererCompanyName ?? '',
      contact_information_control:
        this.tendererResponseData.tendererContactInformation ?? '',
    });
  }
}
